/**
 * Кнопки перехода в другие системы (сквозной вход). Редактируйте только этот файл.
 * url ведёт на /auth/keycloak/start/ целевой системы без форса prompt:
 * при живой сессии Keycloak вход тихий, иначе показывается форма — в любом случае
 * после входа вернёт на указанный next.
 */

function ssoUrl(apiUrl, frontUrl, authStartPath = "auth/keycloak/start/") {
  const next = `${frontUrl.replace(/\/$/, "")}/login/keycloak/callback`;
  const start = `${apiUrl.replace(/\/$/, "")}/${authStartPath.replace(/^\//, "")}`;
  return `${start}?next=${encodeURIComponent(next)}&sso=1`;
}

export const SSO_LINKS = [
  {
    label: "Новая версия (SBS)",
    // У sbs_api старт по пути /api/v1/auth/keycloak/start/
    url: ssoUrl(
      "https://refsbs-api.smartremont.kz",
      "https://refsbs.smartremont.kz",
      "api/v1/auth/keycloak/start/"
    ),
    icon: "fa-solid fa-arrow-up-right-from-square",
    // dest: путь внутри целевой системы для сквозного входа. Не задан — главная.
    // Напр.: dest: '/some-page'
    dest: "",
  },
];
